export const FLOATING_RATE_TYPE = {
  AU: 'Variable',
  DEFAULT: 'Floating',
};
